import { BuilderUpdatableInterface } from '../interfaces/builder-updatable.interface';
import { PartialType, PickType } from '@nestjs/swagger';
import { BuilderDto } from './builder.dto';

export class BuilderUpdateDto
  extends PartialType(PickType(BuilderDto, ['code', 'name', 'archived']))
  implements BuilderUpdatableInterface {}
